/* global VXConfig */

import React        from 'react';
import Flux         from '../../../flux/Flux';

let requestInProgress = false;

function withEventConfig(WrappedComponent) {
	class WithEventConfig extends React.Component {
		constructor(props) {
			super(props);
			
			const queryString  = window.location.search;
			const urlParams    = new URLSearchParams(queryString);
			const date         = urlParams.get('qmdate');

			this.state = {
				date:  date,
				event: Flux.DailyBonus.getEventConfig(date, VXConfig.isVXMobilePlatform),
			};

			this.onDailyBonusConfig = this.onDailyBonusConfig.bind(this);
		}

		componentDidMount() {
			Flux.DailyBonus.addEventConfigLoadedListener(this.onDailyBonusConfig);

			if (null === this.state.event && !requestInProgress) {
				requestInProgress = true;
				Flux.DailyBonus.requestEventConfig(this.state.date, VXConfig.isVXMobilePlatform);
			}
		}

		componentWillUnmount() {
			Flux.DailyBonus.removeEventConfigLoadedListener(this.onDailyBonusConfig);
		}

		onDailyBonusConfig() {
			requestInProgress = false;

			this.setState(state => ({
				event: Flux.DailyBonus.getEventConfig(state.date, VXConfig.isVXMobilePlatform),
			}));
		}

		render() {
			return <WrappedComponent event={this.state.event} qmDate={this.state.date} {...this.props} />;
		}
	}

	return WithEventConfig;
}

export default withEventConfig;
